import { render, staticRenderFns } from "./IconGradePresent.vue?vue&type=template&id=1611e05a"
import script from "./IconGradePresent.vue?vue&type=script&lang=ts"
export * from "./IconGradePresent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports